import React from 'react';

import { useIsEditorToolbarDockedAtTop } from '@confluence/content-types-header/entry-points/useIsEditorToolbarDockedAtTop.tsx';
import { expValEquals } from '@confluence/feature-experiments';

import { EditorConnectionBanner } from './EditorConnectionBanner.tsx';
import { EditorConnectionBannerOfflineMode } from './EditorConnectionBannerOfflineMode.tsx';
import type { EditorConnectionBannerWrapperType } from './EditorConnectionBannerTypes.ts';

export const EditorConnectionBannerWrapper = ({
	triggerAnalyticsEvent,
	collabEditInternetLost,
	collabEditConnectionTimedOut,
	willEditorDisable,
	contentType,
	contentId,
	spaceId,
	fullPageEditorPresetAPI,
	collabEditState,
	isDesktop,
	isLivePage,
	isViewMode,
}: EditorConnectionBannerWrapperType) => {
	const isEditorToolbarDockedAtTop = useIsEditorToolbarDockedAtTop({
		defaultDockedAtTop: !isLivePage,
	});

	const isEditorToolbarHidden = isViewMode || !isEditorToolbarDockedAtTop;

	if (isDesktop || expValEquals('platform_editor_offline_editing_web', 'isEnabled', true)) {
		return (
			<EditorConnectionBannerOfflineMode
				editorType="next"
				triggerAnalyticsEvent={triggerAnalyticsEvent}
				collabEditState={collabEditState}
				willEditorDisable={willEditorDisable}
				contentType={contentType}
				contentId={contentId}
				spaceId={spaceId}
				fullPageEditorPresetAPI={fullPageEditorPresetAPI}
				isEditorToolbarHidden={isEditorToolbarHidden}
			/>
		);
	}

	return (
		<EditorConnectionBanner
			editorType="next"
			triggerAnalyticsEvent={triggerAnalyticsEvent}
			collabEditInternetLost={collabEditInternetLost}
			collabEditConnectionTimedOut={collabEditConnectionTimedOut}
			willEditorDisable={willEditorDisable}
			contentType={contentType}
			contentId={contentId}
			isEditorToolbarHidden={isEditorToolbarHidden}
		/>
	);
};
